
import React from 'react';
import { Check } from 'lucide-react';

const ContactFormSuccess = () => {
  return (
    <div className="bg-green-50 border border-green-200 rounded-lg p-6 text-center">
      <div className="mx-auto flex items-center justify-center w-12 h-12 bg-green-100 rounded-full mb-4">
        <Check className="w-6 h-6 text-green-600" />
      </div>
      <h4 className="text-xl font-montserrat font-bold mb-2">Message Sent!</h4>
      <p className="text-text/80 font-montserrat">Thank you for contacting us. We'll get back to you soon!</p>
    </div>
  );
};

export default ContactFormSuccess;
